const rowsPerPageOptions = [5, 10, 25, 50, 75, 100];
export default rowsPerPageOptions;



// WEBPACK FOOTER //
// ./src/config/rowsPerPageOptions.js